import { Form, Input, InputNumber, Select } from 'antd';
import { FC } from 'react';
import { DOWN, RIGHT, UP } from '../const';
import { LEFT } from '../const';
import { IRule } from '../type';
import RowPosition from '../row-position';
import ColPosition from '../col-position';

const { Item: FormItem } = Form;
const { Item: StyleItem } = Form;

const CellItem: FC<{
  fullPrefix: (string | number)[];
  prefix: (string | number)[];
}> = ({ fullPrefix, prefix }) => {
  const form = Form.useFormInstance();
  return (
    <div className="mb-2">
      <FormItem
        label="单元格定位"
        // name={[...prefix, 'row_config', 'position_method']}
        name={[...prefix, 'grid_position']}
      >
        <Select
          onChange={() => {
            // TODO 行顺序、列顺序的默认值
            // form.setFieldValue(
            //   [...fullPrefix, 'row_config', 'offset_config'],
            //   undefined,
            // );
          }}
          options={[
            {
              label: `关键词`,
              value: 'KEYWORD',
            },
            {
              label: `行列顺序`,
              value: 'ROW_COLUMN',
            },
          ]}
        />
      </FormItem>

      <>
        {/* 如果是关键词- 展示 正则输入框 */}
        <FormItem noStyle shouldUpdate={() => true}>
          {() => {
            const grid_position = form.getFieldValue([
              ...fullPrefix,
              'grid_position',
            ]) as IRule['cell_content_config']['grid_position'];

            if (grid_position === 'KEYWORD') {
              return (
                <Form.Item
                  name={[...prefix, 'keyword']}
                  rules={[{ required: true, message: '', warningOnly: true }]}
                >
                  <Input allowClear placeholder="请输入关键词或正则表达式" />
                </Form.Item>
              );
            }

            /* 如果是行列顺序- 展示 行定位 和 列定位 */

            if (grid_position === 'ROW_COLUMN') {
              return (
                <>
                  <RowPosition prefix={prefix} fullPrefix={fullPrefix} />
                  <ColPosition prefix={prefix} fullPrefix={fullPrefix} />
                </>
              );
            }
          }}
        </FormItem>
      </>

      {/* 单元格偏移  */}

      <FormItem label="单元格偏移">
        <section className="flex gap-4">
          <FormItem
            className="flex-1"
            name={[...prefix, 'left_right_offset', 'direction']}
          >
            <Select
              options={[
                {
                  label: '向左偏移',
                  value: LEFT,
                },
                {
                  label: '向右偏移',
                  value: RIGHT,
                },
              ]}
            />
          </FormItem>
          <FormItem
            className="flex-2"
            name={[...prefix, 'left_right_offset', 'offset']}
          >
            <InputNumber
              suffix="个单元格"
              className="w-full"
              min={0}
              max={99999}
            />
          </FormItem>
        </section>
        <section className="flex gap-4">
          <FormItem
            className="flex-1"
            name={[...prefix, 'up_down_offset', 'direction']}
          >
            <Select
              options={[
                {
                  label: '向上偏移',
                  value: UP,
                },
                {
                  label: '向下偏移',
                  value: DOWN,
                },
              ]}
            />
          </FormItem>
          <FormItem
            className="flex-2"
            name={[...prefix, 'up_down_offset', 'offset']}
            rules={[
              {
                required: true,
                warningOnly: true,
                type: 'number',
                message: '',
              },
            ]}
          >
            <InputNumber
              min={0}
              max={99999}
              suffix="个单元格"
              className="w-full"
            />
          </FormItem>
        </section>
      </FormItem>
    </div>
  );
};

export default CellItem;
